import { render, staticRenderFns } from "./model-detail.vue?vue&type=template&id=f794f1b4&scoped=true&"
import script from "./model-detail.vue?vue&type=script&lang=ts&"
export * from "./model-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f794f1b4",
  null
  
)

export default component.exports